import React, { useEffect, useState } from 'react';

import CloseIcon from '~/icons/components/CloseIcon';
import ReviewsHeader from '~/layout/components/ReviewsHeader';
import {
  ProductDetail,
  ReviewsDrawer as BaseReviewsDrawer,
  useId,
  useReviewsDrawer,
} from '~/techstyle-shared/react-components';
import { useReviewsMetaDataQuery } from '~/techstyle-shared/react-products';

import ReviewsDrawerContent from './ReviewsDrawerContent';

export default function ReviewsDrawer() {
  const [isInitialized, setIsInitialized] = useState(false);
  const [overallFit, setOverallFit] = useState();
  const {
    isReviewsDrawerOpen,
    closeReviewsDrawer,
    groupCode,
    setSizes,
    setCounts,
    product,
    sizesToQuery,
    rating,
  } = useReviewsDrawer();

  const isProductEmpty = Object.keys(product).length === 0;

  const { data, loading } = useReviewsMetaDataQuery(
    {
      groupCode,
      sizes: sizesToQuery.length ? sizesToQuery : undefined,
      rating,
    },
    {
      skip: !groupCode,
      ssr: false,
    }
  );

  useEffect(() => {
    if (!loading && data?.reviewsMetaData) {
      const { sizes, counts, overallFit } = data.reviewsMetaData;

      setSizes(sizes);
      setCounts(counts);
      setOverallFit(overallFit);
      setIsInitialized(true);
    }
  }, [data, loading, setCounts, setSizes]);

  const headerId = useId();

  return (
    <BaseReviewsDrawer
      isOpen={isReviewsDrawerOpen}
      onExit={closeReviewsDrawer}
      titleId={headerId}
      closeIcon={<CloseIcon />}
      header={<ReviewsHeader headerId={headerId} />}
    >
      {!isProductEmpty && (
        <ProductDetail product={product} currentUserStatus={{}}>
          {isInitialized && isReviewsDrawerOpen && (
            <ReviewsDrawerContent overallFit={overallFit} />
          )}
        </ProductDetail>
      )}
    </BaseReviewsDrawer>
  );
}
